<template>
  <v-card :class="{ selected, disabled }">
    <div
      class="inner-wrapper"
      @click="$emit('clicked')"
    >
      <img
        v-if="$vuetify.breakpoint.mdAndUp"
        :src="dealType.icon" />
      <p>{{ dealType.title || dealType.name }}</p>
    </div>

  </v-card>
</template>

<script>
export default {
  name: 'DealTypeCard',
  props: {
    dealType: {
      type: Object,
      default: () => {},
    },
    selected: Boolean,
    disabled: Boolean,
  },
}
</script>

<style lang="scss" scoped>
.v-card {
  width: 100%;
  max-width: 100%;
  height: 40px;
  max-height: 100%;
  margin: auto;

  background-color: white;
  box-shadow: $primaryShadow;
  border-radius: 4px;

  transition: all 0.2s ease-in-out;
  cursor: pointer;

  &.selected {
    background-color: #C2F0F5;
    border: 2px solid $secondaryBlue;
  }

  &.disabled {
    cursor: not-allowed;
    opacity: 0.5;

    div { pointer-events: none; }
  }

  &:hover:not(.disabled) {
    border: 3px solid $primaryBlue;
    transform: scale(1.1);
  }

  &:focus:before {
    opacity: 0;
  }

  & > div:not(.v-card) {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  img {
    width: 95px;
    max-width: 90%;
    margin-bottom: 10px;
  }

  p {
    margin-bottom: 0;
    max-width: 90%;

    color: $textDarkMuted;
    font-family: "Sansation Regular", sans-serif;
    font-size: 14px;
    line-height: 16px;
    text-align: center;

    user-select: none;
  }

  @include md {
    width: 175px;
    height: 140px;
  }
}
</style>
